module.exports = __webpack_public_path__ + "img/stock3.36d54552.png";